import React from 'react';
import NotifierContextProvider, { useNotifierFunctions } from './context';
import Notifier from './Notifier';

export const NotifierProvider = ({ children }: { children: any }) => {
  // @TODO fix type of NotifierContextProvider and Notifier

  return (
    // @ts-ignore
    <NotifierContextProvider>
      {children}
      {/* @ts-ignore */}
      <Notifier />
    </NotifierContextProvider>
  );
};

export { useNotifierFunctions };
